<template>
  <div>
    <div class="container-new">
      <!-- ASIDE -->
      <Aside />
      <!-- ASIDE -->
      <!-- MAIN -->
      <main>
        <h1>Главная</h1>
        <div class="statistics">
          <div class="statistics-item">
            <div class="statistics-info">
              <span class="material-icons-sharp">analytics</span>
              <h3>Статистика</h3>
            </div>
            <div class="middle">
              <PieChart class="statistics-chart" />
            </div>
            <div class="small text-muted">За последние сутки</div>
          </div>

          <div class="statistics-item">
            <div class="statistics-info">
              <span class="material-icons-sharp">trending_up</span>
              <h3>Статистика</h3>
            </div>
            <div class="middle">
              <PieChart class="statistics-chart" />
            </div>
            <div class="small text-muted">За последние сутки</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-info">
              <span class="material-icons-sharp">pie_chart</span>
              <h3>Статистика</h3>
            </div>
            <div class="middle">
              <PieChart class="statistics-chart" />
            </div>
            <div class="small text-muted">За последние сутки</div>
          </div>
        </div>
        <!-- Table -->
        <div class="table-container">
          <h2>Отчеты <span class="primary">ТМЗ</span></h2>
          <table>
            <thead>
              <tr>
                <th>№</th>
                <th>ДЗО</th>
                <th>Месяц</th>
                <th>Утверждено</th>
                <th>Статус</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Астана</td>
                <td>Октябрь 2021</td>
                <td class="success">Да</td>
                <td class="success">Подписан</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Астана</td>
                <td>Ноябрь 2021</td>
                <td class="success">Да</td>
                <td class="success">Подписан</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Астана</td>
                <td>Декабрь 2021</td>
                <td class="success">Да</td>
                <td class="success">Подписан</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Астана</td>
                <td>Январь 2022</td>
                <td class="danger">Нет</td>
                <td class="primary">Создан</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Астана</td>
                <td>Февраль 2022</td>
                <td class="danger">Нет</td>
                <td class="primary">Создан</td>
              </tr>
            </tbody>
          </table>
          <!-- <a class="reveal-rows" href="#">Показать больше</a> -->
        </div>
        <!-- Table -->
      </main>
      <!-- MAIN -->

      <!-- Right Section -->
      <div class="right">
        <!-- top -->
        <div class="top">
          <button id="menu-btn" @click="openMenu">
            <span class="material-icons-sharp"> menu </span>
          </button>
          <!-- <div class="profile">
            <div class="info">
              <p>
                Здравствуйте, <b>{{ USER.first_name | TitleCase }}</b>
              </p>
              <small class="text-muted">{{
                USER.ouser.role[0].name | TitleCase
              }}</small>
            </div>
            <div class="profile-photo">
              <img src="@/assets/avatar.png" alt="Profile photo" />
            </div>
          </div> -->
        </div>
        <!-- top -->
        <!-- recent updates -->
        <div class="recent-updates">
          <h2>Лента</h2>
          <div class="updates">
            <div class="update">
              <div class="profile-photo">
                <img
                  src="@/assets/avatar.png"
                  alt="Profile photo"
                />
              </div>
              <div class="message">
                <p><b>Сериков Серик</b> обновил профиль</p>
                <small class="text-muted">2 Minutes ago</small>
              </div>
            </div>
            <div class="update">
              <div class="profile-photo">
                <img
                  src="@/assets/avatar.png"
                  alt="Profile photo"
                />
              </div>
              <div class="message">
                <p><b>Бериков Самат</b> обновил профиль</p>
                <small class="text-muted">2 Minutes ago</small>
              </div>
            </div>
            <div class="update">
              <div class="profile-photo">
                <img
                  src="@/assets/avatar.png"
                  alt="Profile photo"
                />
              </div>
              <div class="message">
                <p><b>Бериков Самат</b> создал отчет ТМЗ</p>
                <small class="text-muted">2 Minutes ago</small>
              </div>
            </div>
            <div class="update">
              <div class="profile-photo">
                <img
                  src="@/assets/avatar.png"
                  alt="Profile photo"
                />
              </div>
              <div class="message">
                <p><b>Бериков Самат</b> создал отчет ТМЗ</p>
                <small class="text-muted">2 Minutes ago</small>
              </div>
            </div>
          </div>
        </div>
        <!-- recent updates -->
        <!-- Sales -->
        <div class="analytics">
          <h2>Аналитика</h2>
          <div class="item online">
            <div class="icon">
              <span class="material-icons-sharp">dashboard</span>
            </div>
            <div class="item-right">
              <div class="info">
                <h3>Создано отчетов</h3>
                <small class="text-muted">За последние сутки</small>
              </div>
              <h5 class="success">+39%</h5>
              <h3>3849</h3>
            </div>
          </div>
          <div class="item offline">
            <div class="icon">
              <span class="material-icons-sharp">dashboard</span>
            </div>
            <div class="item-right">
              <div class="info">
                <h3>Подписано отчетов</h3>
                <small class="text-muted">За последние сутки</small>
              </div>
              <h5 class="success">+39%</h5>
              <h3>3849</h3>
            </div>
          </div>
          <div class="item customers">
            <div class="icon">
              <span class="material-icons-sharp">dashboard</span>
            </div>
            <div class="item-right">
              <div class="info">
                <h3>Новые пользователи</h3>
                <small class="text-muted">За последние сутки</small>
              </div>
              <h5 class="success">+25%</h5>
              <h3>3849</h3>
            </div>
          </div>
          <div class="item add-product">
            <div>
              <span class="material-icons-sharp">add</span>
              <h3>Создать отчет</h3>
            </div>
          </div>
        </div>
        <!-- Sales -->
      </div>
      <!-- Right Section -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Aside from '@/components/Aside';
import PieChart from "@/components/charts/PieChart";
export default {
  data() {
    return {
      menuOpen: false,
    };
  },
  components: {
    PieChart,
    Aside
  },
  methods: {
    closeMenu: () => {
      const menu = document.querySelector("aside");
      menu.style.display = "none";
    },
    openMenu: () => {
      const menu = document.querySelector("aside");
      menu.style.display = "block";
    },
    accessLevel(roles, level) {
      if (roles) {
        let arr = Object.keys(JSON.parse(JSON.stringify(this.USER.ouser.role)));
        for (const role in arr) {
          if (roles[role].access_level === level) {
            return true;
          }
        }
        return false;
      }
      return false;
    },
  },
  computed: {
    ...mapGetters(["isActiveAccount", "USER"]),
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/icon?family=Material+Icons+Sharp");
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap");
@import url('https://fonts.googleapis.com/css2?family=Vollkorn:wght@400;500;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Display:wght@400;500;600;700;800&display=swap');

// :root {
//   --color-primary: #7380ec;
//   --color-danger: #ff7782;
//   --color-success: #41f1b6;
//   --color-warning: #ffbb55;
//   --color-white: #fff;
//   --color-info-dark: #7d8da1;
//   --color-info-light: #dce1eb;
//   --color-dark: #363949;
//   --color-light: rgba(132, 139, 200, 0.18);
//   --color-primary-variant: #111e88;
//   --color-dark-variant: #677483;
//   --color-background: #f6f6f9;

//   --card-border-radius: 2rem;
//   --border-radius-1: 0.4rem;
//   --border-radius-2: 0.8rem;
//   --border-radius-3: 1.2rem;

//   --card-padding: 1.8rem;
//   --padding-1: 1.2rem;

//   --box-shadow: 0 2rem 3rem var(--color-light);
//   --transition-standard: all 300ms ease;
// }

/* Dark Theme Variables */
.dark-theme-variables {
  --color-background: #181a1e;
  --color-white: #202528;
  --color-dark: #edeffd;
  --color-dark-variant: #a3bdcc;
  --color-primary-variant: #fff;
  --color-light: rgba(0, 0, 0, 0.4);
  --box-shadow: 0 2rem 3rem var(--color-light);
}

* {
  margin: 0;
  padding: 0;
  outline: 0;
  appearance: none;
  border: 0;
  text-decoration: none;
  list-style: none;
  box-sizing: border-box;
}

html {
  font-size: 14px;
}

body {
  width: 100vw;
  height: 100vh;
  font-family: 'Noto Sans Display', sans-serif;
  // background: var(--color-background);
  user-select: none;
  overflow-x: hidden;
}

.container-new {
  display: grid;
  width: 96%;
  margin: 0 auto;
  gap: 1.8rem;
  /* grid-template-columns: 14rem auto; */
  grid-template-columns: 14rem auto 23rem;
  /* grid-template-columns: 1fr 4fr 1fr; */
}

a {
  color: var(--color-dark);
}

img {
  display: block;
  width: 100%;
}

h1 {
  font-weight: 800;
  font-size: 1.8rem;
  color: var(--color-dark);
}

h2 {
  font-size: 1.4rem;
  color: var(--color-dark);
}

h3 {
  font-size: 0.87rem;
  color: var(--color-dark);
}

h4 {
  font-size: 0.8rem;
  color: var(--color-dark);
}

h5 {
  font-size: 0.77rem;
  color: var(--color-dark);
}

small {
  font-size: 0.75rem;
  color: var(--color-dark);
}

.profile-photo {
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 50%;
  overflow: hidden;
}

.text-muted {
  font-size: 0.8rem;
  color: var(--color-info-dark);
}

p {
  color: var(--color-dark-variant);
}

b {
  color: var(--color-primary-variant);
}

.primary {
  color: var(--color-primary);
}

.danger {
  color: var(--color-danger);
}

.warning {
  color: var(--color-warning);
}

.success {
  color: var(--color-success);
}

/* MAIN */
main {
  margin-top: 1.4rem;
}

.statistics-info {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.8rem;
}

.statistics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.6rem;
  text-align: center;
}

.statistics > div {
  background: var(--color-white);
  padding: var(--card-padding);
  border-radius: var(--card-border-radius);
  margin-top: 1rem;
  box-shadow: var(--box-shadow);
  transition: var(--transition-standard);
}

.statistics > div:hover {
  box-shadow: none;
}

.statistics > div span {
  background: var(--color-primary);
  padding: 0.5rem;
  border-radius: 50%;
  color: var(--color-white);
}

.statistics > div:nth-child(2) span {
  background: var(--color-danger);
}

.statistics > div:nth-child(3) span {
  background: var(--color-success);
}

.statistics > div .middle {
  display: flex;
  align-items: center;
  justify-content: center;
}

.statistics h3 {
  font-size: 1rem;
}

.statistics .progress {
  position: relative;
  width: 92px;
  height: 92px;
  border-radius: 50%;
}

.statistics-chart {
  position: relative;
  width: 14vw;
  height: 14vh;
}

.statistics .small {
  display: block;
  margin-top: 1.3rem;
}

/* Table */
// .table-container {
//   margin-top: 2rem;
// }

// .table-container h2 {
//   margin-bottom: 0.8rem;
// }

// main .table-container table {
//   width: 100%;
//   background: var(--color-white);
//   padding: var(--card-padding);
//   border-radius: var(--card-border-radius);
//   text-align: center;
//   box-shadow: var(--box-shadow);
//   transition: var(--transition-standard);
//   color: var(--color-dark);
// }

// main .table-container table:hover {
//   box-shadow: none;
// }

// main table tbody td {
//   height: 2.8rem;
//   border-bottom: 1px solid var(--color-light);
//   color: var(--color-dark-variant);
// }

// main table tbody tr:last-child td {
//   border: none;
// }

// .reveal-rows {
//   display: block;
//   text-align: center;
//   margin: 1rem auto;
//   color: var(--color-primary);
// }

/* Right */
.right {
  margin-top: 1.4rem;
}

.right .top {
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
}

.right .top #menu-btn {
  display: none;
}

.checkbox {
  opacity: 0;
  position: absolute;
}

.label {
  background-color: #111;
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  position: relative;
  height: 26px;
  width: 50px;
  transform: scale(1.5);
}

.label .ball {
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  height: 22px;
  width: 22px;
  transform: translateX(0px);
  transition: transform 0.2s linear;
}

.checkbox:checked + .label .ball {
  transform: translateX(24px);
}

.fa-moon {
  color: #f1c40f;
}

.fa-sun {
  color: #f39c12;
}

// .right .top .profile {
//   display: flex;
//   gap: 2rem;
//   text-align: right;
// }

/* Recent updates */
.right .recent-updates h2 {
  margin-bottom: 0.8rem;
}

.right .recent-updates .updates {
  min-height: 20rem;
  background: var(--color-white);
  padding: var(--card-padding);
  border-radius: var(--card-border-radius);
  box-shadow: var(--box-shadow);
  transition: var(--transition-standard);
}

.right .recent-updates .updates:hover {
  box-shadow: none;
}

.updates .update {
  display: grid;
  grid-template-columns: 2.6rem auto;
  gap: 1rem;
  margin-bottom: 1rem;
}

/* Sales */
.right .analytics {
  margin-top: 2rem;
}

.right .analytics h2 {
  margin-bottom: 0.8rem;
}

.right .analytics .item {
  background: var(--color-white);
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.7rem;
  padding: 1.4rem var(--card-padding);
  border-radius: var(--border-radius-3);
  box-shadow: var(--box-shadow);
  transition: var(--transition-standard);
}

.right .analytics .item:hover {
  box-shadow: none;
}

.right .analytics .item .item-right {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0;
  width: 100%;
}

.right .analytics .item .icon {
  padding: 0.6rem;
  color: var(--color-white);
  border-radius: 50%;
  background: var(--color-primary);
  display: flex;
}

.right .analytics .item.offline .icon {
  background: var(--color-danger);
}

.right .analytics .item.customers .icon {
  background: var(--color-success);
}

.right .analytics .item.add-product {
  background: transparent;
  border: 2px dashed var(--color-primary);
  color: var(--color-primary);
  display: flex;
  justify-content: center;
  align-items: center;
}

.item.add-product div {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.item.add-product div h3 {
  font-weight: 600;
}

/* MEDIA */

@media screen and (max-width: 1200px) {
  .container-new {
    width: 94%;
    grid-template-columns: 7rem auto 23rem;
  }

  main .statistics {
    grid-template-columns: 1fr;
    gap: 0;
  }

  main .table-container {
    width: 94%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin: 2rem 0 0 8.8rem;
  }

  main .table-container table {
    width: 83vw;
  }
}

@media screen and (max-width: 768px) {
  .container-new {
    width: 100%;
    grid-template-columns: 1fr;
  }

  main {
    margin-top: 8rem;
    padding: 0 1rem;
  }

  main .table-container {
    position: relative;
    margin: 3rem 0 0 0;
    width: 100%;
  }

  .table-container table {
    width: 100%;
    margin: 0 auto;
  }

  .right {
    width: 94%;
    margin: 0 auto 4rem;
  }

  .right .top {
    position: fixed;
    top: 0;
    left: 0;
    align-items: center;
    padding: 0 0.8rem;
    height: 4.6rem;
    background: var(--color-white);
    margin: 0;
    width: 100%;
    z-index: 2;
    box-shadow: 0 1rem 1rem var(--color-light);
  }

  .right .top .theme-toggler {
    width: 4.4rem;
    position: absolute;
    left: 66%;
  }

//   .right .profile .info {
//     display: none;
//   }

  .right .top button {
    display: inline-block !important;
    background: transparent;
    cursor: pointer;
    color: var(--color-dark);
    position: absolute;
    left: 1rem;
  }

  .right .top button span {
    font-size: 2rem;
  }
}


.icon {
	width:50px;
	height:50px;
	border-radius:50%;
	overflow:hidden;
	// background:#e4e4e4;
	position:relative;
	float:left;
	margin:0px 0px 10px 10px;
  float: right;
} 

.icon-circle-main {
	width:75px;
	height:75px;
	position:absolute;
	left:0px;
	-webkit-animation:fill 2s infinite;
	-moz-animation:fill 2s infinite;
	animation:fill 2s infinite;
}

.icon-circle-sub-main {
	width:44px;
	height:44px;
	border-radius:50%;
	background:#fff;
	position:absolute;
	left:3px;
	top:3px;
}

/* .icons
{
font-size:2em;
position:absolute;
left: 33px;
top: 33px;
-webkit-animation:iconjump 2s infinite;
-moz-animation:iconjump 2s infinite;
animation:iconjump 2s infinite;  
} */

.custom-icons-container {
	position: absolute;
	top: -20px;
}

.custom-icons {
	font-size:2em;
	position:absolute;
	left: 13px;
	/* top: -13px; */
	font-size: 20px;
	font-family: 'Material Icons Sharp';
	line-height: 1;
	-webkit-animation: iconjump 2s infinite;
	-moz-animation: iconjump 2s infinite;
	animation: iconjump 2s infinite;
}

/* fill color */  
.icon-help-color {
	background: #36429e;
	}
/* icons color */  
.icon-help {
	color: #36429e
}

/* jump social icons */
@-webkit-keyframes iconjump
{
0%{top:33px;}
10%{top:70px;}
20%{top:33px;}
50%{top:33px;}
90%{top:33px;} 
100%{top:33px;}
}

@-moz-keyframes iconjump
{
0%{top:33px;}
10%{top:70px;}
20%{top:33px;}
50%{top:33px;}
90%{top:33px;} 
100%{top:33px;}
}

@keyframes iconjump
{
0%{top:33px;}
10%{top:70px;}
20%{top:33px;}
50%{top:33px;}
90%{top:33px;} 
100%{top:33px;}
}

/* fill background */      
@-webkit-keyframes fill
{
0%{top:100px;}
100%{top:0px;}
}

@-moz-keyframes fill
{
0%{top:100px;}
100%{top:0px;}
}

@keyframes fill
{
0%{top:100px;}
100%{top:0px;}
}

.slider {
  width: 400px;
  text-align: center;
  overflow: hidden;
}

.slides-modal {
}

.slides {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}
.slides::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
// .slides::-webkit-scrollbar-thumb {
//   background: black;
//   border-radius: 10px;
// }
.slides::-webkit-scrollbar-track {
  background: transparent;
}
.slides > div {
  scroll-snap-align: start;
  flex-shrink: 0;
  width: 400px;
  height: 300px;
  margin-right: 50px;
  // background: #bbdefb;
  background-image: linear-gradient(to bottom right, #e3f2fd, #1e88e5);
  transform-origin: center center;
  transform: scale(1);
  transition: transform 0.5s;
  position: relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 50px;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
	padding: 1rem;
  font-size: 1.2rem;
  /* font-size: 100px; */
}

.slider > a {
  display: inline-flex;
  width: 1.5rem;
  height: 1.5rem;
  // background: #1e88e5;
  background-image: linear-gradient(to bottom right, #e3f2fd, #1e88e5);
	color: #fff;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 0 .5rem 1rem 0;
  position: relative;
}
.slider > a:active {
  top: 1px;
}
.slider > a:focus {
  background: #000;
}


</style>
